module.exports = __webpack_public_path__ + "bb3.no2.314219e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bb3.no2.jpg
// module id = macA
// module chunks = 0